export const showModal = (modalType, message, complete, heading, buttonUrl, buttonText, icon) => {
  return {
    type: "SHOW_MODAL",
    modalType,
    message,
    complete,
    heading,
    buttonUrl,
    buttonText,
    icon,
  };
};

export const hideModal = (modalType) => {
  return {
    type: "HIDE_MODAL",
    modalType: modalType,
  };
};



// WEBPACK FOOTER //
// ./src/actions/modal.actions.js